import React, { useState, useContext, useEffect, useRef,useMemo } from 'react';
import { BackgroundContext } from 'context/backgroundContext';
import { CounterContext } from 'context/bestContext';
import MainContext from '../../MainContext';
import { AutenticatedWrapper, HeightSpace } from 'components/wrapper';
import Invoice, { Invoices, Element } from 'components/invoice';
import Currency from 'components/currency';
import DateConvertor from 'components/date-convertor';
import { getOrders } from './container/api';
import OrderModal from './components/order-modal';
import Button from 'components/button';
import styled from 'styled-components';
import { Link, useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Loading from 'components/loading';
import { NotificationCircle } from 'components/wrapper';
import { ThemeContext } from 'context/themeContext';
import { useTranslation } from 'react-i18next';
import * as API from './container/api';
import { RFQBadge } from './components/wrapper';
import { fixFloat } from 'utils';

const AddNewWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  box-sizing: border-box;
  align-items: center;
  padding-top: 0.56vw;
  height: 4.06vw;
  padding-right: ${(props) => (props.rtlDirection ? '0' : '2.08vw')};
  padding-left: ${(props) => (props.rtlDirection ? '2.08vw' : '0')};
`;

function Home(props) {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { notifications } = useContext(MainContext).login;
  const { getInvoicesContext, invoices, totalInvoices, attachments } = useContext(MainContext).orders;
  const { setLeftWidth, setRotateAngle } = useContext(BackgroundContext);
  const [pageNumber, setPageNumber] = useState(2);
  const [openInvoices, setOpenInvoices] = useState([]);
  const [openOrders, setOpenOrders] = useState({});
  const [orderModal, setOrderModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState({});
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [ordersInvoice, setOrdersInvoice] = useState('');
  const [loading, setLoading] = useState(true);
  
  let history = useHistory();
  const { t, i18n } = useTranslation();

  const { invoiceId: propsInvoiceId } = props;

  // const { invoiceId: invoiceUrl } = useParams();
  const invoiceRef = useRef(null);
  
  
  const selectedOrder = useMemo(
    () => {
      let orders=openOrders[selectedInvoice._id];
      if(orders){
        let o=orders.find(x=>x._id==selectedOrderId);
        return o || {};
      }else
        return {};
    },
    [selectedOrderId,openOrders]
  );
  //TODO move openOrders and its update functions to context
  const updateOpenOrder=(invoiceId,changedOrder)=>{
    
    setOpenOrders((openOrders)=>{
      let helper = { ...openOrders };
    
      let indexHelper = helper[invoiceId].findIndex((x) => x._id==changedOrder._id);
      if(indexHelper!=-1){
        helper[invoiceId][indexHelper] = changedOrder;
      }
      return helper;

    });
  }
 
  useEffect(() => {
    if (axios.defaults.headers.common.family) {
      getInvoicesByFilter(1);
      setPageNumber(2);
    }
  }, [axios.defaults.headers.common.family]);

  useEffect(() => {
    // this is defined for auto-scroll on invoice when we are using an external url for invoice
    const targetInvoice = invoices.find((invoice) => invoice._id === propsInvoiceId);
    
    if (window.location.href.indexOf("invoice") > -1 && !loading) {
      if (targetInvoice) {
        if (!openInvoices.includes(propsInvoiceId)) {
          onInvoiceClick({ id: targetInvoice._id, orders: targetInvoice.orders })
        }
        invoiceRef.current = document.getElementById(targetInvoice._id);
        invoiceRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else if (!window.location.hash){
          if (pageNumber - 1 < totalInvoices / 10) {
            console.log("doesn't scroll")
            getInvoicesByFilter(pageNumber);
            setPageNumber(pageNumber + 1);
          }
        }
    }
    if (axios.defaults.headers.common.family && !loading && invoices.length === 0) {
      history.push('/start');
    }

  }, [invoices, loading, propsInvoiceId]);

  useEffect(() => {
    if(!window.location.href.includes('/order/')){
      if (propsInvoiceId && pageNumber === 2) {
        let orders = [];
        for (let j = 0; j < invoices.length; j++) {
          if (invoices[j]._id === propsInvoiceId) {
            orders = invoices[j].orders;
          }
        }
        
        onInvoiceClick({ id: propsInvoiceId, orders });
      }
    }
  }, [invoices]);

  const onCreateNewClick = () => { };

  const onOrderClick = async (order, invoiceId, invoice) => {
    setSelectedInvoice(invoice);
    setOrdersInvoice(invoiceId);
    setSelectedOrderId(order._id);
    toggleOrderModal();
  };

  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
    //remove the part of url that is related to order if the order modal is closed
    if(orderModal && window.location.href.includes('/order/')) {
      const currentUrl = window.location.pathname; 
      const baseUrl = window.location.origin; 
      const updatedPath = currentUrl.replace(/\/order\/[^/]+$/, ''); 
      window.history.replaceState(null, '', baseUrl + updatedPath);
    }
  };

  const getInvoicesByFilter = async (i) => {
    setLoading(true);
    let data = { pageNumber: i };
    await getInvoicesContext(data);

    setLoading(false);
  };
  const onInvoiceClick = async ({ id, orders }) => {
    let openInvoiceHelper = [...openInvoices];
    let ordersHelper = [];
    let statusHelper = [];
    orders?.map((order) => {
      ordersHelper.push(order._id);
      statusHelper.push({ _id: order._id, status: order.status,UIValues:{
          attachmentsNO:0,
          messagesNO:0,
          loading:true
      } });
    });
    
    if (openInvoiceHelper.includes(id)) {
      //close the invoice
      openInvoiceHelper.splice(openInvoiceHelper.indexOf(id), 1);
      setOpenInvoices(openInvoiceHelper);
    } else {
      openInvoiceHelper.push(id);
      setOpenOrders({
        ...openOrders,
        [id]: statusHelper,
      });
      setOpenInvoices(openInvoiceHelper);
      const result = await getOrders({ orders: ordersHelper });
      result.orders=result.orders.map((x)=>{
        return {...x,UIValues:{
          attachmentsNO:0,
          messagesNO:0,
          loading:false
        }}
      });
      
      
      for (let o of result.orders){
          Promise.all([
            API.getAttachedFiles(o._id),
            API.getComments(o._id)
          ]).then(([attachments,messages])=>{
            o.UIValues.attachmentsNO=attachments.length;
            o.UIValues.messagesNO=messages.messages.length;
            updateOpenOrder(id,o);
          })
      }
      


      setOpenOrders({ ...openOrders, [id]: result.orders });
    }
    
  };
  const countInvoiceElements = (orders) => {
    let partCount = 0;
    let totalWeight = 0;
    orders?.map((order) => {
      partCount = partCount + order.quantity;
      totalWeight = totalWeight + order.weight * order.quantity;
    });
    return { partCount, totalWeight };
  };
  setRotateAngle(0);
  setLeftWidth(0);
  let content = [];

  let notificationByinvoice = {};
  notifications.map((notification) => {
    if (!notificationByinvoice[notification.invoice_id]) {
      notificationByinvoice[notification.invoice_id] = [notification];
    } else {
      notificationByinvoice[notification.invoice_id].push(notification);
    }
  });

  


  invoices.map((invoice) => {
    content.push(
      <Invoice

        ref={invoiceRef} //for autoscroll
        invoiceId={invoice._id}
        link={`/dashboard/invoice/${invoice._id}`}


        onClick={() =>
          onInvoiceClick({ id: invoice._id, orders: invoice.orders })
        }
        open={openInvoices.includes(invoice._id)}
        orderIds={invoice.orders}
        orders={openOrders[invoice._id] ? openOrders[invoice._id] : []}
        onOrderClick={(e) => onOrderClick(e, invoice._id, invoice)}
        updateOpenOrder={updateOpenOrder}
        notifications={notificationByinvoice[invoice._id] || []}
        isOrderModalOpen= {orderModal}
      >
        <Element rtlDirection={rtlDirection} left="3.0192vw">
          {invoice.receipt_code}
        </Element>
        <Element rtlDirection={rtlDirection} left="10.879vw">
          <DateConvertor value={invoice.created_at} />
        </Element>
        <Element rtlDirection={rtlDirection} left="26.392vw">
          {invoice.status === '1' || invoice.status === '7' || invoice.status === '8'
            ? t('dashboard.table.status.Uncomplete')
            : invoice.status === '2'
              ? t('dashboard.table.status.Order registered')
              : invoice.status === '3'
                ? t('dashboard.table.status.Preparing for print')
                : invoice.status === '4'
                  ? t('dashboard.table.status.Printing')
                  : invoice.status === '5'
                    ? t('dashboard.table.status.Packaging & Shipping')
                    : invoice.status === '6'
                      ? t('dashboard.table.status.Shipped')
                      : invoice.status === '9'
                      ? t('dashboard.table.status.Waiting for price')
                      : null}
        </Element>
        <Element rtlDirection={rtlDirection} left="43.31vw">
          <span>{countInvoiceElements(invoice.orders).partCount + ' ' + t('dashboard.table.parts')+ ', ' }</span>
          <span style={{ direction: 'ltr',display:'inline-block' }}> {countInvoiceElements(invoice.orders).totalWeight >= 1000 ? `${fixFloat((countInvoiceElements(invoice.orders).totalWeight)/1000)} kg` : `${fixFloat(countInvoiceElements(invoice.orders).totalWeight)} g`}</span>
        </Element>
        <Element rtlDirection={rtlDirection} left="70.90vw">
          {/* <Currency value={invoice.total_price} /> this line is chenged to below one by qazal for preventing of huge number*/}
          { invoice.status !== '9' ?  
            <Currency
              value={
                Number.isInteger(invoice.total_price)
                  ? invoice.total_price
                  : parseFloat(invoice.total_price).toFixed(2)
              }
            /> : 
            <RFQBadge theme={theme}>RFQ</RFQBadge>
          }
         
        </Element>
        {(invoice.status === '1') && invoice.payment_type === 'online' && (
          <Element rtlDirection={rtlDirection} left="88.90vw" top="0.9vw">
            <Link to={`/checkout/${invoice._id}`} style={{ textDecoration: 'none' }}>
              <Button
                onClick={onCreateNewClick}
                marginTop={0}
                text={t('checkout.step3.Payment')}
                size="medium"
              />
            </Link>
          </Element>
        )}
        {notificationByinvoice[invoice._id] && (
          <Element rtlDirection={rtlDirection} left="78.90vw">
            <NotificationCircle width="2vw" fontSize="1vw" top="-0.4vw" theme={theme}>
              {notificationByinvoice[invoice._id].length}
            </NotificationCircle>
          </Element>
        )}
      </Invoice>
    );
  });

  const handleScroll = (e) => {
    const threshold = 60;
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + threshold;
  
    if (bottom && pageNumber - 1 < totalInvoices / 10) {
      getInvoicesByFilter(pageNumber);
      setPageNumber(pageNumber + 1);
    }
  };

  return (
    <AutenticatedWrapper rtlDirection={rtlDirection}>
      <OrderModal
        open={orderModal}
        toggle={toggleOrderModal}
        selectedOrder={selectedOrder}
        updateOpenOrder={updateOpenOrder}
        selectedInvoice={selectedInvoice}
        invoiceId={ordersInvoice}
        
      />
      <AddNewWrapper rtlDirection={rtlDirection}>
        <Link to="/start" style={{ textDecoration: 'none' }}>
          <Button
            onClick={onCreateNewClick}
            marginTop={0}
            text={t('dashboard.table.ADD NEW ORDER')}
            size="medium"
            image={true}
          />
        </Link>
      </AddNewWrapper>
      <Invoices theme={theme} rtlDirection={rtlDirection} onScroll={handleScroll}>
        {content}
        {loading && (
          // <>
          //   <HeightSpace height="0.78vw" />
          //   <Loading width="96vw" height="4.164vw" borderRadius="2.082vw" />
          // </>

          // new Loading 
          <Invoice orderIds={[]} orders={[]} loading={true} >
              <Element left="3.0192vw" rtlDirection={rtlDirection}>
                <Loading width="4vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="10.879vw" rtlDirection={rtlDirection}>
                <Loading width="8.589vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="26.392vw" rtlDirection={rtlDirection}>
                <Loading width="8.589vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="43.31vw" rtlDirection={rtlDirection}>
                <Loading width="8.589vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="60vw" rtlDirection={rtlDirection}>
                <Loading width="8.589vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="70.90vw" rtlDirection={rtlDirection}>
                <Loading width="8.589vw" height="1.249vw" borderRadius="0.728vw" />
              </Element>
              <Element left="75vw" rtlDirection={rtlDirection}/>
            </Invoice>
        )}
      </Invoices>
    </AutenticatedWrapper>
  );
}

export default Home;
